import { MODULES } from './modules';

export type RequiredFeaturesType = string[];

type UserType = {
  roles: string[];
  company: {
    features: string[];
  };
};

export const hasMatchedValueInArray = (
  valueArray: string[],
  testArray: string[],
): boolean =>
  valueArray
    .map((value) => testArray.includes(value))
    .reduce((acc: boolean, cur: boolean): boolean => acc || cur, false);

export const hasFeature = (
  user: UserType,
  requiredFeatures: RequiredFeaturesType = [],
): boolean => {
  const { features } = user.company;
  if (requiredFeatures.length === 0) {
    return true;
  }
  if (
    requiredFeatures.includes(MODULES.TEMP) &&
    !features.includes(MODULES.TEMP)
  ) {
    return false;
  }
  return hasMatchedValueInArray(requiredFeatures, [...features]);
};
